export const VERSION = PACKAGE_CURRENT_VERSION || "TESTVERSION"
